import { BlankMediaUtils } from "../../../../utils";
import { NotFoundPage } from "../../../shared/error/NotFoundPage";
import {
  BlankMediaTypeImporterApplicationPage,
  BlankMediaTypeProfessionalUserApplicationPage,
} from "./";

export function BlankMediaTypeApplicationPageRouter() {
  const urlParams = BlankMediaUtils.getUrlParams();
  const renderForm = () => {
    if (!urlParams.applicationType) return;

    switch (urlParams.applicationType) {
      case "Importer":
        return (
          <BlankMediaTypeImporterApplicationPage
            key={urlParams.applicationId}
          />
        );
      case "ProfessionalUser":
        return (
          <BlankMediaTypeProfessionalUserApplicationPage
            key={urlParams.applicationId}
          />
        );
      default:
        return <NotFoundPage />;
    }
  };

  return renderForm();
}
